import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({ standalone: false, 
  selector: 'hunt-pack-added-to-hunt',
  templateUrl: './hunt-pack-added-to-hunt.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class HuntPackAddedToHuntComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { id: string; name: string; huntPackagesAdded: number }
  ) {}
}

@Component({ standalone: false, 
  selector: 'hunt-pack-added-to-template',
  templateUrl: './hunt-pack-added-to-template.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class HuntPackAddedToTemplateComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { id: string; name: string; huntPackagesAdded: number }
  ) {}
}

@Component({ standalone: false, 
  selector: 'collection-added-to-hunt',
  templateUrl: './collection-added-to-hunt.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class CollectionAddedToHuntComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { id: string; name: string; huntPackagesAdded: number }
  ) {}
}

@Component({ standalone: false, 
  selector: 'collection-added-to-template',
  templateUrl: './collection-added-to-template.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class CollectionAddedToTemplateComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { id: string; name: string; huntPackagesAdded: number }
  ) {}
}

@Component({ standalone: false, 
  selector: 'mark-saved',
  templateUrl: './mark-saved.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkSavedComponent {}

@Component({ standalone: false, 
  selector: 'mark-reset',
  templateUrl: './mark-reset.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkResetComponent {}

@Component({ standalone: false, 
  selector: 'mark-copied',
  templateUrl: './mark-copied.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkCopiedComponent {}

@Component({ standalone: false, 
  selector: 'mark-deployed',
  templateUrl: './mark-deployed.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkDeployedComponent {}

@Component({ standalone: false, 
  selector: 'mark-staged',
  templateUrl: './mark-staged.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkStagedComponent {}

@Component({ standalone: false, 
  selector: 'mark-removed',
  templateUrl: './mark-removed.html',
  styleUrls: ['./cyborg-snackbar.scss'],
})
export class MarkRemovedComponent {}
